import { baseThemeValues } from 'constants/common';

export const transferTreeHeaderTheme = {
  bg: 'palette.secondary.70',
  borderColor: 'palette.transparent',
  borderRadius: '8px',
  borderWidth: '0px',
  circle: 'palette.secondary.90',
  icon: 'palette.secondary.5',
  subtitle: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '14px',
    fontWeight: 400,
    text: 'palette.secondary.5',
  },
  title: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '24px',
    fontWeight: 700,
    text: 'palette.secondary.5',
  },
};
